import { forwardRef, useMemo } from "react";
import {
  Input,
  Select,
  Flex,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";
import { useDebouncedCallback } from "use-debounce";

export const MatchString = forwardRef(
  (
    {
      // @ts-ignore
      column: { filterValue, preFilteredRows, setFilter },
      // @ts-ignore
      placeholder = "",
    },
    ref
  ) => {
    const count = preFilteredRows.length;

    const handleInputChange = async (value) => {
      //debounce the setfilter, race conditions.
      setFilter(value || undefined); // Set undefined to remove the filter entirely
    }
    const debounced = useDebouncedCallback(handleInputChange, 4.5);
    return (
      <Input
        value={filterValue || ""}
        // @ts-ignore
        ref={ref}
        onChange={(e) => {
          debounced(e.target.value);
        }}
        placeholder={placeholder || `Search ${count} records...`}
      />
    );
  }
);

export const SelectFilter = forwardRef(
  // @ts-ignore
  ({ column: { filterValue, setFilter } }, ref) => {
    return (
      <Select
        value={filterValue}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}
        // @ts-ignore
        ref={ref}
      >
        <option value="">All</option>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </Select>
    );
  }
);

export const websiteFilter = (rows, id, filterValue) => {
  if (!filterValue) {
    return rows;
  }

  return rows.filter((row) => {
    const rowValue = row.values[id];
    if (filterValue === "yes") {
      return rowValue;
    }

    return !rowValue;
  });
};

export const NumberRangeFilter = forwardRef(
  (
    {
      // @ts-ignore
      column: { filterValue = [], preFilteredRows, setFilter, id },
    },
    ref
  ) => {
    const [min, max] = useMemo(() => {
      let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
      let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
      preFilteredRows.forEach((row) => {
        min = Math.min(row.values[id], min);
        max = Math.max(row.values[id], max);
      });
      return [min, max];
    }, [id, preFilteredRows]);

    return (
      <Flex alignItems="center" justifyContent="center">
        <Input
          value={filterValue[0] || ""}
          type="number"
          // @ts-ignore
          ref={ref}
          min={0}
          w="32"
          mr="2"
          onChange={(e) => {
            const val = e.target.value;
            setFilter((old = []) => [
              val ? parseInt(val, 10) : undefined,
              old[1],
            ]);
          }}
          placeholder={`Min (${min})`}
        />
        to
        <Input
          value={filterValue[1] || ""}
          min={0}
          type="number"
          w="32"
          ml="2"
          onChange={(e) => {
            const val = e.target.value;
            setFilter((old = []) => [
              old[0],
              val ? parseInt(val, 10) : undefined,
            ]);
          }}
          placeholder={`Max (${max})`}
        />
      </Flex>
    );
  }
);
